<template>
  <div class="ss-qb">
    <span class="ss-mode" data-mode>
      <v-icon size="15">{{ mode.icon }}</v-icon>
      <span>
        <b>{{ mode.title }}</b>
        <template v-if="mode.detail"> · {{ mode.detail }}</template>
      </span>
    </span>
    <span class="ss-sp"></span>
    <div class="ss-pw">
      <button
        type="button"
        class="ui-btn ui-btn--sm"
        data-open="quick"
        aria-haspopup="dialog"
        :aria-expanded="String(open)"
        @click="toggle"
      >
        <v-icon size="16">mdi-auto-fix</v-icon>
        {{ $t("settings_shell.quick.button") }}
        <v-icon size="14">mdi-chevron-down</v-icon>
      </button>
      <set-panel v-if="open && !ctl.isPhone" :key="ctl.ui.pop" :kind="ctl.ui.pop" />
    </div>
  </div>
</template>

<script>
import { DAYS, detectCycle, isUniform } from "../settingsLogic";
import SetPanel from "./SetPanel.vue";

const HOSTED = ["quick", "cycle", "uniform"];

/** Iznad rokova: kako su rokovi podešeni (ciklus / isti svaki dan / ručno) i dugme "Brzo podešavanje". */
export default {
  name: "SetQuickBar",
  components: { SetPanel },
  inject: { ctl: "settingsCtl" },
  computed: {
    open() {
      return HOSTED.includes(this.ctl.ui.pop);
    },
    rules() {
      return DAYS.map((day) => {
        const row = this.ctl.form.days[day];
        return { before: row.day_before_limit, after: row.day_after_limit, time: row.time };
      });
    },
    mode() {
      const cycle = detectCycle(this.rules);
      if (cycle) {
        return {
          icon: "mdi-calendar-sync-outline",
          title: this.$t("settings_shell.mode.cycle"),
          detail: this.$t("settings_shell.mode.cycle_open", { day: this.$t(DAYS[cycle.o]), time: cycle.time }),
        };
      }
      if (isUniform(this.rules)) {
        return { icon: "mdi-clock-outline", title: this.$t("settings_shell.mode.uniform"), detail: "" };
      }
      return { icon: "mdi-tune-variant", title: this.$t("settings_shell.mode.manual"), detail: "" };
    },
  },
  methods: {
    toggle() {
      this.ctl.ui.pop = this.open ? null : "quick";
    },
  },
};
</script>
